{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Mostra totes les opcions",
  "Spoiler_Reveal_Tooltip": "Fes clic per revelar-ho",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Piula això",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "L'element està reduït",
  "Spoiler_Reveal_Video_CTA": "Revela el vídeo",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Amplia la imatge",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Mostra tots els resultats",
  "Spoiler_Reveal_Image_Placeholder": "Aquesta imatge conté un espòiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Cerca el control lliscant",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Pots votar més d’una resposta.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Mostra més controls de so",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Tanca",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "S'està carregant {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Més informació",
  "Spoiler_Insert_Tooltip": "Espòiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volum",
  "Spoiler_Reveal_Gallery_Placeholder": "Aquesta galeria conté un espòiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Reserva ara",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Deixa de silenciar",
  "Spoiler_Reveal_Gallery_CTA": "Revela la galeria",
  "Poll_Viewer_ShowLess_CTA": "Mostra'n menys",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Silencia",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anònim(s)",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Segueix",
  "VerticalEmbed_Products_Button": "Compra ara",
  "Poll_Viewer_Toast_Error_ServerDown": "No s'ha pogut connectar amb el servidor. Torna-ho a provar més tard.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} persona ha votat per aquesta resposta",
  "Poll_Viewer_VoteCount": "{{number}} vots",
  "VerticalEmbed_Events_Button": "Registra't ara",
  "Spoiler_Reveal_Image_CTA": "Revela la imatge",
  "Poll_Viewer_Toast_Error_Connection": "No hi ha Internet. Comprova la teva connexió.",
  "Poll_Viewer_Visibility_Owner_Footer": "Només pots veure els resultats.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} persones han votat per aquesta resposta",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "L'element està ampliat",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Aquest vídeo conté un espòiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Mostra l'entrada completa",
  "UploadFile_Viewer_Download": "Baixa {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
